import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-resume',
  template: `
    <div>
      <div class="col-md-4 container-height resume-border text-center">
        <h1 class="name">Ron Mares</h1>
        <hr>
        <section class="left-spacer">
          <h2>Profile</h2>
          <div class="left-title-border"></div>
          <p>B.S in Computer Information Systems in June 2013. Excellent problem solving skills and fast learner. I can manage multiple projects with deadlines always in mind. I work best when I have many projects to work with at once. I thrive in great teamwork environments where there is a good sense of humor and good laughs and beautiful people where there is a mutual respect for silence.</p>
        </section>
        <section class="left-spacer">
          <h2>Contact</h2>
          <div class="left-title-border"></div>
          <span>720-484-1490</span><br>
          <span>Sanford, NC</span><br>
          <span>ron.mares@gmail.com</span>
        </section>
        <section class="left-spacer">
          <h2>Skills</h2>
          <div class="left-title-border"></div>
          <rm-progress-bars color="green" label="HTML/CSS" percent="80"></rm-progress-bars>
          <rm-progress-bars color="blue" label="Bootstrap" percent="80"></rm-progress-bars>
          <rm-progress-bars color="yellow" label="Foundation" percent="30"></rm-progress-bars>
          <rm-progress-bars color="red" label="Sass" percent="65"></rm-progress-bars>
          <rm-progress-bars color="blue" label="Node" percent="50"></rm-progress-bars>
          <rm-progress-bars color="yellow" label="Angular" percent="65"></rm-progress-bars>
          <rm-progress-bars color="green" label="Perl" percent="70"></rm-progress-bars>
          <rm-progress-bars color="blue" label="Javascript" percent="80"></rm-progress-bars>
          <rm-progress-bars color="red" label="Linux" percent="70"></rm-progress-bars>
          <rm-progress-bars color="green" label="MySQL" percent="60"></rm-progress-bars>
          <rm-progress-bars color="yellow" label="JQuery" percent="40"></rm-progress-bars>
          <rm-progress-bars color="blue" label="Python" percent="10"></rm-progress-bars>
          <rm-progress-bars color="yellow" label="Mongo" percent="20"></rm-progress-bars>
        </section>
      </div>
      <div class="col-md-8">
        <section>
          <h2>Work Experience</h2>
          <div class="right-title-border"></div>
          <!--Start Job-->
          <div>
            <h3 class="title-color-base title-yellow">Marketing Technologies Inc.
              <small> April 2015 - Present</small>
            </h3>
          </div>
          <div>
            <h4>Front End Engineer</h4>
            <p>SaaS Firm</p>
            <p>I'm building and maintaining data-driven, RESTful software applications built with Angular and Angular 2+.</p>
            <p>Some other things I've done for MTI include:</p>
            <ul>
              <li>writing lots of PERL programs, including a parts ordering system</li>
              <li>implementing Centos server setups</li>
              <li>building Wordpress sites</li>
            </ul>
          </div>
          <div>
          </div>
          <!--end job-->
          <!--Start Job-->
          <div>
            <h3 class="title-color-base title-green">Retriever Software
              <small class="muted_text"> April 2014 - September 2014</small>
            </h3>
          </div>
          <div>
            <h4>PHP Developer - IT Support</h4>
            <p>Theater point of sale company. They provide complete functionality of all the theaters day
              to day operations including projector and movie scheduling, marquee signage, movie
              schedule auditorium displays, networking, and point of sale terminals.
            </p>
            <p>
              <strong>Wordpress</strong>
            </p>

            <ul>
              <li>Creating custom pages with HTML5, CSS3</li>
              <li>Maintaining Wordpress sites</li>
              <li>Creating Wordpress sites</li>
              <li>Modified plugins</li>
              <li>Created plugins</li>
            </ul>

            <p> <strong>PHP</strong></p>
            <ul>
              <li>Maintaining company's e-commerce software</li>
              <li>Building new features for their e-commerce application</li>
              <li>Updating websites for WordPress</li>
              <li>Creating pages for Wordpress</li>
            </ul>

            <p><strong>Javascript</strong></p>

            <ul>
              <li>Creating a theater management application</li>
              <li>Creating new functionality for Retriever's theater management system</li>
              <li>Updating and maintaining websites for WordPress</li>
            </ul>

            <p><strong> IT support and Development</strong></p>

            <ul>
              <li>Built several Linux servers with the following for Debian and RedHat based distros</li>
              <li>LAMP</li>
              <li>FTP</li>
              <li>Hamachi</li>
              <li>Remote Access</li>
              <li>PostgreSQL</li>
              <li>Firewalls</li>
            </ul>

            <p><strong>Phone Support not only for Retriever's software but also troubleshooting network failures for their clients.</strong></p>
          </div>
          <!--End Job-->
          <!--Start Job-->
          <div>
            <div>
              <h3 class="title-color-base title-blue">CLVR
                <small class="muted_text"> January 2013 - March 2014</small>
              </h3>
            </div>
            <div>
              <h4>Junior Full Stack Developer</h4>
              Video production, digital marketing, web development, e-commerce and complex systems architecture offers Google AdWords, social media management and distribution services.
              <br/><br>

              <p>
                <strong>Roles & Responsibilities</strong>
              </p>
              <ul>
                <li>Stack includes HTML5, CSS3, PHP5, Javascript, JQuery, MySQL</li>
                <li>Maintenance of client websites using Wordpress and PHP solutions.</li>
                <li>Adding functionality to websites using PHP, JS, JQuery, PHP</li>
                <li>Building custom pages with Wordpress and HTML5 frameworks</li>
                <li>Building custom web applications using Javascript, MySQL, and PHP</li>
              </ul>
            </div>
            <div>
            </div>
          </div>
          <!--End Job-->
        </section>
        <section>
          <h2>Education</h2>
          <div class="right-title-border"></div>
          <span class="muted_text title-span title-color-base title-red" style="width: 100%;">Metropolitan State University 2007- 2013</span>
          <div>
            <p>Bachelor of Science, Computer Information Systems</p>
            <p>
              <small>
                Certificate Web Developer in Information Systems<br>
                Certificate Network Specialist in Information Systems
              </small>
            </p>
          </div>
        </section>
      </div>
      <div class="clearfix"></div>
    </div>
  `,
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/resume/resume.component.ts